import type { BadgeVariant } from '../../../components/ui';

export type EmployeeStatus = 'working' | 'available' | 'review' | 'blocked' | 'paused' | 'setup' | 'terminated';

export interface StatusMeta {
  variant: BadgeVariant;
  label: string;
}

export const STATUS_MAP: Record<EmployeeStatus, StatusMeta> = {
  working: { variant: 'info', label: 'Working' },
  available: { variant: 'success', label: 'Available' },
  review: { variant: 'warning', label: 'Waiting for review' },
  blocked: { variant: 'danger', label: 'Blocked' },
  paused: { variant: 'warning', label: 'Paused' },
  setup: { variant: 'info', label: 'Needs setup' },
  terminated: { variant: 'neutral', label: 'Terminated' },
};

// Map the agent runtime statuses (`idle | running | waiting | error | paused | terminated`)
// onto the designer employee status taxonomy so the UI can render either shape.
export function mapRuntimeStatus(raw: string | null | undefined, attn?: boolean): EmployeeStatus {
  switch (raw) {
    case 'running':
      return 'working';
    case 'waiting':
      return attn ? 'review' : 'available';
    case 'error':
      return 'blocked';
    case 'paused':
      return 'paused';
    case 'terminated':
      return 'terminated';
    default:
      return 'available';
  }
}

export type PerfTone = 'ok' | 'warn' | 'bad';

export function perfTone(value: number): PerfTone {
  if (value >= 0.9) return 'ok';
  if (value >= 0.75) return 'warn';
  return 'bad';
}
